/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material';
import { FormErrors, IAnomalias, IDetalhesAnomalia } from '../../../services/api/anomaly/AnomalyService';
import SelectAnomalia from './SelectAnomalia';
import { formatDateForInputDate, formatDateWhitoutHour, helpers } from '../../../services/helpers/helpers';
import { estruturaItensMap, type TypeEstruturas } from '../Reports/Risrot/risrotEstruturaCatalog';
import { image } from 'html2canvas/dist/types/css/types/image';

const opcoesLocalizacaoAnomalia = [
    { value: 'Acesso', label: 'Acesso' },
    { value: 'Crista', label: 'Crista' },
    { value: 'Talude de montante', label: 'Talude de montante' },
    { value: 'Talude de jusante', label: 'Talude de jusante' },
    { value: 'Ombreira Direita', label: 'Ombreira Direita' },
    { value: 'Ombreira Esquerda', label: 'Ombreira Esquerda' },
    { value: 'Área de justante ao pé da barragem', label: 'Área de justante ao pé da barragem' },
    { value: 'Reservatório', label: 'Reservatório' },
    { value: 'Tomada d\'água', label: 'Tomada d\'água' },
    { value: 'Vertedouro', label: 'Vertedouro' },
    { value: 'Sistema de drenagem superficial', label: 'Sistema de Drenagem Superficial' },
    { value: 'Drenagem interna / Dreno fundo', label: 'Drenagem Interna / Dreno Fundo' },
    { value: 'Instrumentação', label: 'Instrumentação' },
    { value: 'Sinalização', label: 'Sinalização' }
];

const opcoesMagnitude = [
    { value: 'Insignificante', label: 'Insignificante' },
    { value: 'Pequeno', label: 'Pequeno' },
    { value: 'Média', label: 'Média' },
    { value: 'Grande', label: 'Grande' }
];

const opcoesSituacao = [
    { value: 'NI', label: 'Não identificado (NI): Condição satisfatória.' },
    { value: 'PV', label: '1ª ocorrência (PV): Sem ocorrência pretérita registrada.' },
    { value: 'RE', label: 'Recorrente (RE): Ocorrência já registrada.' },
    { value: 'PC', label: 'Constante(PC): Ocorrência permaneceu constante.' },
    { value: 'TR', label: 'Tratada(TR): Ocorrência identificada e registrada previamente, com ação de tratamento realizada.' },
    { value: 'AU', label: 'Aumentou(AU): Agravamento da ocorrência' },
    { value: 'DS', label: 'Desapareceu(DS): Anomalia evidênciada em inspeção anterior não apresenta-se aparente no dia da inspeção.' },
    { value: 'NI_2', label: 'Não inspecionado(NI): Não houve condições para a inspeção visual (descrever motivação no quadro "Observações")' },
    { value: 'NA', label: 'Não Aplicavél (N.A): Item não se aplica a estrutura avaliada' }
];

const opcoesNPA = [
    {
        value: 'Normal',
        label: 'Normal',
        helperText: 'Quando não há comprometimento da estrutura.'
    },
    {
        value: 'Atenção',
        label: 'Atenção',
        helperText: 'Quando não há comprometimento imediato da estrutura, mas haverá caso venha a progredir.'
    },
    {
        value: 'Alerta',
        label: 'Alerta',
        helperText: 'Quando há comprometimento da estrutura.'
    },
    {
        value: 'Emergência',
        label: 'Emergência',
        helperText: 'Quando a anomalia representa alta probabilidade de rompimento da barragem.'
    }
];

export const estruturaAnomaliasMap: Record<string, { value: string; label: string }[]> = {
    'Crista': [
        { value: 'fissura_trinca', label: 'Fissura / Trinca' },
        { value: 'ausencia_protecao', label: 'Ausência de proteção' },
        { value: 'subsidencias_buracos', label: 'Subsidências, depresões ou buracos' },
        { value: 'erosoes_superficiais', label: 'Erosões ou ravinamentos superficiais' },
        { value: 'vegetacao_arborea', label: 'Vegetação arbórea ou arbustiva' },
        { value: 'acumulo_agua', label: 'Acúmulo de água (Inclinação)' },
        { value: 'defeito_drenagem', label: 'Defeito nos dispositivos de Drenagem' },
        { value: 'defeitos_leira', label: 'Defeitos na leira' },
        { value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
    ],
    'Talude de Montante': [
        { value: 'erosoes', label: 'Erosões ou ravinamentos' },
        { value: 'fissura_trinca', label: 'Fissura / Trinca' },
        { value: 'ausencia_protecao', label: 'Ausência de proteção' },
        { value: 'vegetacao_irregular', label: 'Vegetação falha ou crescimento irregular' },
        { value: 'riprap_danificado', label: 'Rip-Rap danificado ou incompleto' },
        { value: 'conformacao_inadequada', label: 'Conformação inadequada' },
        { value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
        { value: 'escorregamentos', label: 'Escorregamentos ou Abatimentos' },
    ],
    'Talude de Jusante': [
        { value: 'erosoes', label: 'Erosões ou ravinamentos' },
        { value: 'fissura_trinca', label: 'Fissura / Trinca' },
        { value: 'ausencia_protecao', label: 'Ausência de proteção' },
        { value: 'vegetacao_irregular', label: 'Vegetação falha ou crescimento irregular' },
        { value: 'riprap_danificado', label: 'Rip-Rap danificado ou incompleto' },
        { value: 'conformacao_inadequada', label: 'Conformação inadequada' },
        { value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
        { value: 'escorregamentos', label: 'Escorregamentos ou Abatimentos' },
        { value: 'areas_umidas', label: 'Áreas úmida, encharcadas/fofas ou surgências' },
    ],
    'Ombreiras e Jusante do Pé': [
        { value: 'erosoes', label: 'Erosões ou ravinamentos' },
        { value: 'desprendimento_blocos', label: 'Desprendimento de blocos' },
        { value: 'fraturamento', label: 'Fraturamento' },
        { value: 'deslizamento', label: 'Deslizamento / rastejo' },
        { value: 'vegetacao_densa', label: 'Vegetação densa' },
        { value: 'areas_umidas', label: 'Áreas úmida, encharcadas/fofas ou surgências' },
        { value: 'alteracao_solo', label: 'Alteração no solo / rocha' },
        { value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
        { value: 'movimento_massas', label: 'Movimento de massas dos taludes' },
    ],
    'Reservatório': [
        { value: 'praia_inadequada', label: 'Praia inadequada' },
        { value: 'borda_insuficiente', label: 'Borda livre insuficiente' },
        { value: 'deslizamento_margens', label: 'Deslizamento/Desmoronamento nas margens' },
        { value: 'assoreamento', label: 'Assoreamento' },
        { value: 'presenca_animais', label: 'Presença de animais (Formigueiros,tocas,etc.)' },
        { value: 'vegetacao_densa', label: 'Vegetação densa' },
        { value: 'reservatorio_seco', label: 'Reservatório encontrava-se seco:' },
        { value: 'vertimento_extravasor', label: 'Ocorria vertimento pelo extravasor:' },
    ],
    'Sistema de Drenagem Superficial': [
        { value: 'canaletas_danificadas', label: 'Canaletas danificadas / obstruídas' },
        // eslint-disable-next-line quotes
        { value: 'escada_danificada', label: "Escada descida d'agua danificada" },
        { value: 'caixa_assoreada', label: 'Caixa de passagem assoreada' },
        { value: 'caixa_danificada', label: 'Caixa de passagem danificada' },
        { value: 'canal_periferico', label: 'Canal periférico danificado/ obstr.' },
        { value: 'surgencia', label: 'Surgência (especificar estrutura)' },
        { value: 'erosao', label: 'Erosão (especificar estrutura)' },
        { value: 'canais_perifericos', label: 'Canais periféricos' },
    ],
    'Vertedouro': [
        { value: 'trincas', label: 'Trincas ou Fissuras' },
        { value: 'desplacamento', label: 'Desplacamento ou foliações' },
        { value: 'infiltracoes', label: 'Infiltrações' },
        { value: 'deslocamentos', label: 'Deslocamentos' },
        { value: 'turbidez_elevada', label: 'Turbidez elevada' },
        { value: 'ferragem_exposta', label: 'Ferragem exposta' },
        { value: 'obstrucao', label: 'Obstrução' },
        { value: 'necessidade_limpeza', label: 'Necessidade de Limpeza' },
    ],
    'Sistema de Drenagem Interna': [
        { value: 'carreamento_finos', label: 'Carreamento de finos' },
        { value: 'turbidez_elevada', label: 'Turbidez elevada' },
        { value: 'bacia_assoreada', label: 'Bacia de dissipação assoreada' },
        { value: 'dreno_afogado', label: 'Dreno afogado' },
        { value: 'ferro_bacterias', label: 'Presença de ferro bactérias' },
        { value: 'fluxo_dreno', label: 'Ocorria fluxo pelo dreno de fundo:' },
    ],
    'Instrumentação': [
        { value: 'acesso_precario', label: 'Acessos Précario' },
        { value: 'ausencia_instrumentos', label: 'Ausência de instrumentos' },
        { value: 'falta_protecao', label: 'Falta de proteção dos instrumentos' },
        { value: 'sem_identificacao', label: 'Instrumento sem identificação' },
        { value: 'avaria_instrumento', label: 'Avaria no instrumento' },
    ],
    'Sinalização': [
        { value: 'placa_tombada', label: 'Placa tombada' },
        { value: 'ausencia_placa', label: 'Ausência de placa de identificação' },
        { value: 'identificacao_ilegivel', label: 'Identificação ilegível' },
        { value: 'ausencia_placas_rota', label: 'Ausência de placas de rota de fuga' },
    ],
};

export interface ImgData {
    data: string,
    date: string,
    legenda: string,
    nome: string
}

interface FormEditAnomalyProps {
    data: IAnomalias;
    currentDetalhe: IDetalhesAnomalia;
    handleChange: <K extends keyof IAnomalias>(key: K, value: IAnomalias[K]) => void;
    handleChangeDetalhe: <K extends keyof IDetalhesAnomalia>(key: K, value: IDetalhesAnomalia[K]) => void;

    handleChangeFile: (index: number, e: React.ChangeEvent<HTMLInputElement>) => void;
    handleChangeLegenda: (index: number, newLegenda: string) => void;

    imageLegenda: string;
    erros: any;
    imageDate: string;
    handleImageDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    hasAddPermission?: boolean;
    hasEditPermission?: boolean;
    imagens: ImgData[] | undefined
}
const converterItensParaOpcoes = (itens: string[]) => {
    return itens.map(item => ({
        value: item,
        label: item
    }));
};


export default function FormEditAnomaly({
    data,
    currentDetalhe,
    handleChange,
    handleChangeDetalhe,

    handleChangeFile,
    handleChangeLegenda,

    erros,
    imagens,

    hasAddPermission = false,
    hasEditPermission = false,
}: FormEditAnomalyProps) {
    const selectedEstrutura = data.estrutura as TypeEstruturas;
    const isEditing = data.uuid ? true : false;
    // const isFormDisabled = !isEditing ? !hasAddPermission : !hasEditPermission;
    const opcoesAnomalias = selectedEstrutura ? converterItensParaOpcoes(estruturaItensMap[selectedEstrutura] || []) : [];
    const detalhesErros: any = (erros.detalhes || {});
    return (
        <Grid container spacing={2} padding={2}>
            <Grid item xs={6}>
                <SelectAnomalia
                    options={opcoesLocalizacaoAnomalia}
                    label='Estrutura'
                    value={data.estrutura}
                    onChange={(e) => handleChange('estrutura', e.target.value)}
                    // required={true}
                    erro={erros.estrutura}
                    disabled
                />
            </Grid>

            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label='Data da Inspeção'
                    InputLabelProps={{ shrink: true }}
                    disabled
                    type='date'
                    value={currentDetalhe.data_inspecao}
                    onChange={(e) => handleChangeDetalhe('data_inspecao', e.target.value)}
                    error={detalhesErros.data_inspecao}
                    required
                />
            </Grid>

            <Grid item xs={6}>
                {/* <SelectAnomalia
                    options={opcoesAnomalias}
                    label='Anomalia'
                    value={currentDetalhe.item}
                    disabled
                    onChange={(e) => handleChangeDetalhe('item', e.target.value)}
                    // required={true}
                    erro={detalhesErros.item}
                /> */}
                <TextField
                    fullWidth
                    label='Anomalia'
                    multiline
                    value={currentDetalhe.item}
                    // onChange={(e) => handleChangeDetalhe('observacoes_gerais', e.target.value)}
                    disabled
                    // error={detalhesErros.observacoes_gerais}
                />
            </Grid>

            <Grid item xs={6}>
                <SelectAnomalia
                    options={opcoesSituacao}
                    label='Situação'
                    value={currentDetalhe.situacao}
                    onChange={(e) => handleChangeDetalhe('situacao', e.target.value)}
                    required={true}
                    erro={detalhesErros.situacao}
                />
            </Grid>

            <Grid item xs={6}>
                <SelectAnomalia
                    options={opcoesMagnitude}
                    label='Magnitude'
                    value={currentDetalhe.magnitude}
                    onChange={(e) => handleChangeDetalhe('magnitude', e.target.value)}
                    required={true}
                    erro={detalhesErros.magnitude}
                />
            </Grid>

            <Grid item xs={6}>
                <SelectAnomalia
                    options={opcoesNPA}
                    label='NPA'
                    value={currentDetalhe.npa}
                    onChange={(e) => handleChangeDetalhe('npa', e.target.value)}
                    erro={detalhesErros.npa}
                />
            </Grid>

            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label='Código de indentificação da anomalia'
                    multiline
                    value={currentDetalhe.codigo_anomalia}
                    onChange={(e) => handleChangeDetalhe('codigo_anomalia', e.target.value)}
                    error={detalhesErros.observacoes_gerais}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label='Observações da Inspeção Atual'
                    multiline
                    value={currentDetalhe.observacoes_gerais}
                    onChange={(e) => handleChangeDetalhe('observacoes_gerais', e.target.value)}
                    rows={2}
                    error={detalhesErros.observacoes_gerais}
                />
            </Grid>

            <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Typography variant="h6" gutterBottom>Dados da Imagem</Typography>
            </Grid>

            {imagens && (
                imagens.map((img, index) => (
                    <Grid item xs={12} key={index}>
                        <Box marginTop={2} gap={2}>
                            <Typography variant="subtitle1" marginBottom={1}>Imagem Atual:</Typography>
                            <Box
                                border="2px solid black"
                                display="flex"
                                borderRadius="5px"
                                alignItems="center"
                                justifyContent="center"
                                maxWidth="100%"
                                maxHeight="400px"
                                overflow="hidden"
                            >
                                <img
                                    src={img.data}
                                    alt="Imagem da Anomalia Existente"
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                            </Box>
                            {img.date && <Typography variant="caption" display="block" textAlign="center" marginTop={1}>Data: {formatDateWhitoutHour(img.date)}</Typography>}
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                <TextField
                                    sx={{ marginTop: '5px' }}
                                    fullWidth
                                    label='Legenda da imagem'
                                    type='text'
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => handleChangeLegenda(index, e.target.value)}
                                    value={img.legenda}
                                    disabled
                                />
                                {/* <TextField
                                    sx={{ marginTop: '5px' }}
                                    fullWidth
                                    label='Arquivo'
                                    type='file'
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => handleChangeFile(index, e as React.ChangeEvent<HTMLInputElement>)}
                                    inputProps={{ accept: '.jpeg,image/jpeg, .gif, .png, image/png' }}
                                /> */}
                            </Box>
                        </Box>
                    </Grid>
                ))
            )}

            <Grid item xs={12}><Divider /></Grid>

            {data.estrutura === 'Reservatório' && (
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingX: 2 }}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={currentDetalhe.reservatorio_seco} onChange={(e) => handleChangeDetalhe('reservatorio_seco', e.target.checked)} />} label="Reservatório encontrava-se seco ?" />
                            <FormControlLabel control={<Checkbox checked={currentDetalhe.vertimento_extravasor} onChange={(e) => handleChangeDetalhe('vertimento_extravasor', e.target.checked)} />} label="Ocorria vertimento pelo extravasor ?" />
                        </FormGroup>
                    </Box>
                </Grid>
            )}
            {data.estrutura === 'Sistema de Drenagem Interna' && (
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingX: 2 }}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={currentDetalhe.fluxo} onChange={(e) => handleChangeDetalhe('fluxo', e.target.checked)} />} label="Ocorria fluxo pelo dreno de fundo ?" />
                        </FormGroup>
                    </Box>
                </Grid>
            )}
        </Grid>
    );
}
